import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { UFBNoticeClickEvent } from '@udemy/browse-event-tracking';
import { Tracker } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { toBusinessUdemy } from '@udemy/organization';
import { BlockList } from '@udemy/react-core-components';
import { useUDData } from '@udemy/ud-data';
import styles from "../../components/explore-menu.module.css";
import { HeaderButton, HeaderDropdown, HeaderMenu } from '../header-dropdown.react-component';
export const TryUFBDropdown = observer(({
  className
}) => {
  const {
    Config
  } = useUDData();
  const {
    gettext,
    locale
  } = useI18n();
  const homeUrl = toBusinessUdemy('', {
    ref: 'ub_header_home'
  });
  const plansUrl = toBusinessUdemy('plans', {
    ref: 'ufb_header_plans'
  });
  const demoUrl = toBusinessUdemy('request-demo-mx', {
    ref: 'ufb_header_demo'
  });
  const handleClickUBHomeClick = url => {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'ub_header_home',
      url
    }));
  };
  const handlePlansClick = url => {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'ufb_header_plans',
      url
    }));
  };
  const handleDemoClick = url => {
    Tracker.publishEvent(new UFBNoticeClickEvent({
      locale,
      placement: 'ufb_header_demo',
      url
    }));
  };
  const hasOrganization = Config.brand.has_organization;
  return !hasOrganization ? /*#__PURE__*/React.createElement(HeaderDropdown, {
    className: className,
    a11yRole: "description",
    trigger: /*#__PURE__*/React.createElement(HeaderButton, {
      componentClass: "a",
      "data-purpose": "try-ufb-dropdown-trigger",
      href: homeUrl,
      target: "_blank",
      rel: "noopener",
      onClick: () => handleClickUBHomeClick(homeUrl)
    }, gettext('Udemy Business'))
  }, /*#__PURE__*/React.createElement(HeaderMenu, null, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['explore-menu-container'], styles['try-ufb-dropdown-menu'])
  }, /*#__PURE__*/React.createElement(BlockList, {
    size: "small",
    className: classNames(styles['section'], styles['full-width']),
    iconAlignment: "right"
  }, /*#__PURE__*/React.createElement(BlockList.Item, {
    href: plansUrl,
    target: "_blank",
    rel: "noopener",
    className: classNames(styles['item']),
    onClick: () => handlePlansClick(plansUrl)
  }, gettext('Compare Plans')), /*#__PURE__*/React.createElement(BlockList.Item, {
    href: demoUrl,
    target: "_blank",
    rel: "noopener",
    className: classNames(styles['item']),
    onClick: () => handleDemoClick(demoUrl)
  }, gettext('Try Udemy Business')))))) : null;
});
//# sourceMappingURL=try-ufb-dropdown.react-component.js.map